import { dbTableCampaign } from "@dataseat-dsp-client/lib-reporter";

export const APP_MEASURE_SELECT_QUERY =
  dbTableCampaign.APP_MEASURE_SELECT_QUERY;

export const getCohortedAppMeasureExpr =
  dbTableCampaign.getCohortedAppMeasureExpr;
